import Box from '@mui/material/Box'
import { colors } from '@shared'
import type { PropsWithChildren } from 'react'

export const LoginLayout = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        background: `linear-gradient(135deg, ${colors.background.primary} 0%, ${colors.background.secondary} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-50%',
          right: '-20%',
          width: '600px',
          height: '600px',
          background: `radial-gradient(circle, ${colors.base.KestrixPrimary}15 0%, transparent 70%)`,
          borderRadius: '50%',
          pointerEvents: 'none'
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-30%',
          left: '-10%',
          width: '500px',
          height: '500px',
          background: `radial-gradient(circle, ${colors.base.KestrixPrimary}10 0%, transparent 70%)`,
          borderRadius: '50%',
          pointerEvents: 'none'
        }
      }}
    >
      {children}
    </Box>
  )
}
